import React from "react";
import "../styles/experience.css";
import { experiences } from "../assets/data";
// import Anchor, { HighlightText } from "./CustomElements";
import "../styles/portfolio.css";
// import { gsap } from "gsap";
// import experience_summary from "../assets/experience_summary_data";
// import FontAwesomeIcon from "../assets/FontAwesomeIcons/FontAwesomeIcon";

// Helper function to calculate total time
const calculateTotalTime = (startTime) => {
  const startDate = new Date(Date.parse(startTime));
  const endDate = new Date();
  const diffInMs = endDate - startDate;
  const diffInMonths = diffInMs / (1000 * 60 * 60 * 24 * 30);
  const years = Math.floor(diffInMonths / 12);
  const months = Math.round(diffInMonths % 12);

  return `${years} Years ${months} Months`;
};

const ExperienceSection = () => {
  return (
    <div className="section3 animation">
      <h1 className="skillTitle">Experiences</h1>
      <div className='experience_container'>
        {
          experiences.map((x) => {
            const totalTime = x.endTime === "Present" ? calculateTotalTime(x.startTime) : x.total_time;

            return (
              <div className='exp_details' key={x.key}>
                <h2 className='exp_title'>{x.role}<span className='company'>{' @ '}{x.company}</span></h2>
                <span className='exp_desc'>{totalTime}{' | '}{x.startTime}{' - '}{x.endTime}{' | '}{x.place}</span>
                <p className='exp_work'>
                  {x.workDetails}
                </p>
              </div>
            );
          })
        }
      </div>
      {/* <div className="experience_container" data-scroll>
        <div className="experience_header">
          <h1 className="experience_title">Official Experience Summary</h1>
          <div>
            <Button className="button">View Resume</Button>
          </div>
        </div>
        <Hr />
        <div className="experience_data_container">
          <ExperienceDetails experience_summary={experience_summary} />
        </div>
      </div> */}
    </div>
  );
};

export default ExperienceSection;


/*
const ExperienceDetails = () => {
  const sortedExperiences = [...experience_summary].sort(
    (a, b) => b.order - a.order
  );
  const timelineRef = useRef(null);

  const [expandedCard, setExpandedCard] = useState(null);

  const handleCardClick = (index) => {
    if (expandedCard === index) {
      setExpandedCard(null);
      gsap.to(`.details-${index}`, { height: 0, duration: 0.5, opacity: 0 });
    } else {
      if (expandedCard !== null) {
        gsap.to(`.details-${expandedCard}`, {
          height: 0,
          duration: 0.5,
          opacity: 0,
        });
      }
      setExpandedCard(index);
      gsap.to(`.details-${index}`, {
        height: "auto",
        duration: 0.5,
        opacity: 1,
      });
    }
  };

  useEffect(() => {
    const elements = timelineRef.current.querySelectorAll(".timeline_items");

    gsap.fromTo(
      elements,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1, stagger: 0.3 }
    );
  }, []);

  return (
    <div className="portfolio-container">
      {sortedExperiences.map((experience, index) => (
        <div key={index} className="experience-card">
          <div className="experience_header">
            <h2>{experience.timePeriod}</h2>
            <h2>
              {experience.role} at{" "}
              <Anchor href={experience.companyUrl}>{experience.company}</Anchor>
              <FontAwesomeIcon
                icon="fa-sharp fa-regular fa-angle-down"
                size={30}
                className="icons"
                onClick={() => handleCardClick(index)}
                style={{ display: expandedCard === 0 ? "none" : "" }}
              />
              <FontAwesomeIcon
                icon="fa-sharp fa-regular fa-angle-up"
                size={30}
                className="icons"
                onClick={() => handleCardClick(index)}
                style={{ display: expandedCard === 0 ? "" : "none" }}
              />
            </h2>
          </div>
          <div
            className={`details details-${index}`}
            style={{ height: 0, opacity: 0, overflow: "hidden" }}
            ref={timelineRef}
          >
            <p>{experience.roleType}</p>
            <div className="experience_timeline">
              {experience.experiences
                .sort((a, b) => b.order - a.order)
                .map((exp, idx) => (
                  <div className="timeline_items" key={idx}>
                    <div className="timeline_period_container">
                      <h3>{exp.timePeriod}</h3>
                    </div>
                    <div className="timeline_details_container">
                      {exp.training.length > 0 && (
                        <div className="training_container">
                          <h4>
                            <HighlightText>Training Experience</HighlightText>
                          </h4>
                          {exp.training.map((train, id) => (
                            <div key={id}>
                              <ul>
                                {train.trainingExperiene.map(
                                  (expDetail, detailIdx) => (
                                    <li key={detailIdx}>{expDetail}</li>
                                  )
                                )}
                              </ul>
                              <p>
                                <b className="tech_stack">Tech Stack:</b>{" "}
                                {train?.techStack?.join(", ")}
                              </p>
                            </div>
                          ))}
                        </div>
                      )}
                      {exp.project.length > 0 && (
                        <div className="project_exp_container">
                          <h4>
                            <HighlightText>
                              Project : {exp.project[0].projectName}
                            </HighlightText>
                          </h4>
                          <ul>
                            {exp.project[0].projectExperiences.map(
                              (expDetail, detailIdx) => (
                                <li key={detailIdx}>{expDetail}</li>
                              )
                            )}
                          </ul>
                          <p>
                            <b className="tech_stack">Tech Stack :</b>{" "}
                            {exp?.project[0]?.techStack?.join(", ")}
                          </p>
                        </div>
                      )}
                      {exp.bench.length > 0 && (
                        <div className="bench_exp_container">
                          <h4>
                            <HighlightText>Bench Activities</HighlightText>
                            <span className="duration">
                              ({exp.bench[0].benchDuration})
                            </span>
                          </h4>
                          <div>
                            <ul>
                              {exp.bench[0].benchActivities.map(
                                (activity, detailIdx) => (
                                  <li key={detailIdx}>{activity}</li>
                                )
                              )}
                            </ul>
                          </div>
                        </div>
                      )}
                      {exp.hackathon.length > 0 && (
                        <div className="hackathon_exp_container">
                          <h4>
                            <HighlightText>
                              Participated {exp.hackathon.length} Hackathon
                              {exp.hackathon.length > 1 ? "s" : ""}
                            </HighlightText>
                          </h4>
                          {exp.hackathon.map((hack, id) => (
                            <div key={id} className="hackathon_card">
                              <p>
                                <span className="tech_stack">
                                  Hackathon Name :{" "}
                                </span>
                                {hack.hackathonName}
                              </p>
                              <p>
                                <span className="tech_stack">
                                  Description :{" "}
                                </span>
                                {hack.hackathonDescription}
                              </p>
                              <p>
                                <span className="tech_stack">Tech Stack :</span>{" "}
                                {hack?.hackathonTechStack?.join(", ")}
                              </p>
                              <p>
                                <span className="tech_stack">Result : </span>
                                {hack.hackathonResult}
                              </p>
                              <p>
                                <Anchor
                                  href={hack.hackathonProjectPresentation}
                                >
                                  Project Presentation
                                </Anchor>
                                <Anchor href={hack.hackathonCertificate}>
                                  Certificate
                                </Anchor>
                              </p>
                            </div>
                          ))}
                        </div>
                      )}
                      {exp.awards.length > 0 && (
                        <div className="award_exp_container">
                          <h4>
                            <HighlightText>
                              Received {exp.awards.length} Awards
                            </HighlightText>
                          </h4>
                          <ul>
                            {exp.awards.map((award, id) => (
                              <li key={id}>
                                <Anchor href={award.awardCertificate}>
                                  {award.awardName}
                                </Anchor>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                      {exp.certifications.length > 0 && (
                        <div className="certificates_exp_container">
                          <h4>
                            <HighlightText>Certifications</HighlightText>
                          </h4>
                          <ul>
                            {exp.certifications.map((cert, id) => (
                              <li key={id}>
                                <Anchor href={cert.certificate}>
                                  {cert.certificationName}
                                </Anchor>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                      {exp.learnedNewTechStacks.length > 0 && (
                        <div className="learning_new_tech_container">
                          <h4>
                            <HighlightText>
                              Learned New Tech Stacks
                            </HighlightText>
                          </h4>
                          <ul>
                            {exp.learnedNewTechStacks.map((tech, id) => (
                              <li key={id}>{tech}</li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
*/